import { t } from "i18next";
import React from "react";
import {
    checkIfModeOfSaleFranchiseExist,
    checkIfModeOfSaleFranchiseExistAndArchived,
    INITIAL_SALE_MODE_FORM_STATE,
} from "./modeOfSaleCheckers";
import { getSalesSupportUpdated } from "@helpers/general";
import { showSuccessToast } from "@components/Common/SuccessToast";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import {
    CLICK_AND_COLLECT_TRANSLATIONS,
    DELIVERY_TRANSLATIONS,
    DINE_IN_TRANSLATIONS,
    DRIVE_THROUGH_TRANSLATIONS,
    RESTAURANT_TRANSLATIONS,
    TAKEAWAY_TRANSLATIONS,
} from "@constants/index";
import ErrorToast from "@components/Common/ErrorTost";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { toast } from "react-toastify";
export const formatCreateLabel = (inputValue: any) => (
    <span>
        {inputValue} ( {t("New tag")} )
    </span>
);

export const formatCreateLabelModeOfSale = (inputValue: any) => (
    <span>
        {inputValue} ( {t("New sales method")} )
    </span>
);

export function buildCommonPayload(
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    tags: any,
    id: any,
    formState: any,
    salesSupport: any,
    isShopEmpty: any,
    isFranchiseEmpty: any,
    oneShop: any,
    shopId: any,
    tagsData: any,
    isModeOfSaleFranchiseExist: any
) {
    let dataToSend: any = [];
    let commonPayload = {
        userId: userID,
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        isEmpty: tags.length === 0,
        isAddTag: true,
        isUpdated: true,
        data: {
            [id]: {
                designation: formState.saleMode,
                tag: tagsData,
                display_name: formState.displayName,
                support_vente: salesSupport,
                isArchived: false,
                isFavorite: isShopEmpty || isFranchiseEmpty,
                state: isShopEmpty || !oneShop,
                shopId: shopId,
                advancedDisplayName: formState.advancedDisplayName,
            },
        },
    };
    if (oneShop) {
        if (isFranchiseEmpty) {
            dataToSend.push(
                { ...commonPayload, shopId: [shopId] },
                { ...commonPayload, shopId: [0] }
            );
        } else if (!isModeOfSaleFranchiseExist) {
            dataToSend.push(
                {
                    ...commonPayload,
                    shopId: [shopId],
                    isFavorite: isShopEmpty,
                    state: isShopEmpty,
                },
                {
                    ...commonPayload,
                    shopId: [0],
                    isFavorite: false,
                    state: true,
                }
            );
        }
    } else {
        dataToSend.push({ ...commonPayload, shopId: [0] });
    }
    return dataToSend;
}

export function getModeOfSaleStatus({
    formState,
    salesMode,
    oneShop,
    modeOfSaleFranchise,
    modeSaleData,
    dataFranchiseArchive,
}: any) {
    const id = salesMode.find((elt: any) => elt.label === formState.saleMode)
        ?.value;

    const isFranchiseEmpty = oneShop
        ? modeOfSaleFranchise.othersData.modeOfSaleFranchise.length === 0
        : modeSaleData.data.length === 0;

    const isShopEmpty = modeSaleData.data.length === 0;

    const isModeOfSaleFranchiseExist = checkIfModeOfSaleFranchiseExist(
        formState,
        modeOfSaleFranchise
    );

    const isModeOfSaleFranchiseExistAndArchived = checkIfModeOfSaleFranchiseExistAndArchived(
        formState,
        dataFranchiseArchive
    );

    return {
        id,
        isFranchiseEmpty,
        isShopEmpty,
        isModeOfSaleFranchiseExist,
        isModeOfSaleFranchiseExistAndArchived,
    };
}

export function prepareEditData(
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    tags: any,
    formState: any,
    salesSupport: any,
    shopId: any,
    tagsData: any,
    dataSale: any,
    dataState: any
) {
    const dataConfig = [
        {
            userId: userID,
            shopId: [shopId],
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            isEmpty: tags.length === 0,
            isUpdated: true,
            isAddTag: true,
            data: {
                [dataSale.Id]: {
                    designation: formState.saleMode,
                    tag: tagsData,
                    display_name: formState.displayName,
                    support_vente: salesSupport,
                    isArchived: dataSale.isArchived,
                    state:
                        Object.keys(dataState).length === 0
                            ? dataSale.state
                            : dataSale.Id === dataState.id
                            ? dataState.state
                            : dataSale.state,
                    isFavorite: dataSale.isFavorite,
                    shopId: shopId,
                    advancedDisplayName: formState.advancedDisplayName,
                },
            },
        },
    ];

    const oldData = {
        designation: dataSale["Mode of sale"],
        tag: dataSale.tag,
        display_name: dataSale.display_name,
        support_vente: dataSale.support_vente,
        isArchived: dataSale.isArchived,
        state: dataSale.state,
        isFavorite: dataSale.isFavorite,
        shopId: shopId,
        advancedDisplayName: dataSale.advancedDisplayName,
    };

    const updatedData = getSalesSupportUpdated(
        oldData,
        dataConfig[0].data[dataSale.Id],
        "KIOSK",
        "support_vente"
    );

    return { dataConfig, oldData, updatedData };
}

export const resetAfterModeOfSaleUpdate = ({
    setState,
    tagsData,
    setIsLoading,
    setIsEdited,
    setTagsData,
    setModalState,
    setDataIsUpdated,
    setIsValidateButtonDisabled,
    setSalesSupport,
}: any) => {
    setSalesSupport([]);
    setState((prev: any) => ({
        ...prev,
        tags: [...prev.tags, tagsData],
        salesSupportData: [],
    }));
    showSuccessToast(`${t("The sales method is changed successfully")}`);
    setIsLoading(false);
    setIsEdited(false);
    clearMultiCustomSelectionData();
    clearData();
    setTagsData([]);
    setModalState((prev: any) => ({
        ...prev,
        isAddModeOfSaleClicked: false,
    }));
    setDataIsUpdated?.(true);
    setIsValidateButtonDisabled(false);
};

export const resetFormState = ({
    setSalesSupport,
    setIsLoading,
    setDataSale,
    setIsEdited,
    setLocalFilterActive,
    setNumberActive,
    numberActive,
    setState,
    tagsData,
    setTagsData,
    setFormState,
    setIsValidateButtonDisabled,
    setDataIsUpdated,
}: any) => {
    showSuccessToast(t("Sale mode is successfully added")!);
    setSalesSupport([]);
    setIsLoading(false);
    setDataSale([]);
    setIsEdited(false);
    setLocalFilterActive(false);
    setNumberActive(numberActive + 1);
    setState((prev: any) => ({
        ...prev,
        tags: [...prev.tags, tagsData],
        salesSupportData: [],
    }));
    setTagsData([]);
    setDataIsUpdated(true);
    clearMultiCustomSelectionData();
    clearData();
    setFormState(INITIAL_SALE_MODE_FORM_STATE);
    setIsValidateButtonDisabled(false);
};

export const translatedSaleMethod: any = {
    [t("Takeaway")]: TAKEAWAY_TRANSLATIONS,
    [t("In delivery")]: DELIVERY_TRANSLATIONS,
    [t("Dine-in")]: DINE_IN_TRANSLATIONS,
    [t("Click and Collect")]: CLICK_AND_COLLECT_TRANSLATIONS,
    [t("Drive-through")]: DRIVE_THROUGH_TRANSLATIONS,
    [t("Restaurant")]: RESTAURANT_TRANSLATIONS,
};

export function initializeSalesData(
    SalesModesTypesAndTag: any,
    setState: Function
) {
    let data = (SalesModesTypesAndTag.saleMode || []).map((element: any) => ({
        ...element,
        label: t(element.label),
    }));
    setState((prev: any) => ({
        ...prev,
        language: SalesModesTypesAndTag.languages || [],
        salesMode: data,
        tags: SalesModesTypesAndTag.tags || [],
    }));
}

export function extractUniqueIds(data: any[], subKey?: string): string[] {
    if (!data) return [];

    let ids: string[] = [];

    data.forEach((item) => {
        if (subKey && Array.isArray(item[subKey])) {
            item[subKey].forEach((subItem: any) => {
                if (subItem.Id) ids.push(subItem.Id);
            });
        } else if (item.Id) {
            ids.push(item.Id);
        }
    });

    return [...new Set(ids)];
}

export function archiveModeSale(shopsModeSaleData: any) {
    const data = shopsModeSaleData?.data ?? [];
    return extractUniqueIds(data, "subRows");
}

export function archiveModeOfSaleFranchise(archivedModeOfSaleFranchise: any) {
    const data =
        archivedModeOfSaleFranchise?.othersData?.archivedModeOfSaleFranchise ??
        [];
    return extractUniqueIds(data);
}

export function associateModeOfSale(shopsModeSaleData: any) {
    const data = shopsModeSaleData?.data ?? [];
    return extractUniqueIds(data, "subRows");
}

export function isModeOfSaleExist(
    selectedRows: any,
    dataAssociate: any,
    setIsArchiveModalOpened: Function
) {
    const isExist = selectedRows.some((el: any) =>
        dataAssociate.includes(el.Id)
    );

    if (isExist) {
        ErrorToast(
            t(
                "Please note that you cannot archive an item assigned to stores."
            )!
        );
    } else {
        setIsArchiveModalOpened(true);
    }
}

export function createModeOfSaleData(
    el: any,
    userID: any,
    franchiseID: string,
    operatorID: string,
    uuidUser: any
) {
    return {
        userId: userID,
        shopId: [el.shopId],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        isShop: false,
        data: {
            [el.Id]: {
                designation: el["Mode of sale"],
                tag: el.tag,
                display_name: el.display_name,
                support_vente: el.support_vente,
                isArchived: false,
                state: el.shopId === "0" ? true : el.state,
                isFavorite: el.isFavorite,
                shopId: el.shopId,
                advancedDisplayName: el.advancedDisplayName,
            },
        },
    };
}

export function isInclude(element: any, array: any[]) {
    return array.includes(element);
}
export function createDataConfig(
    el: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    tags: any,
    editedDataModeOfSale: any,
    salesSupport: any
) {
    return {
        userId: userID,
        shopId: [el.shopId],
        franchiseId: franchiseID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        isEmpty: tags.length === 0,
        isUpdated: true,
        isAddTag: true,
        data: {
            [el.Id]: {
                designation: editedDataModeOfSale.data[el.Id].designation,
                tag: editedDataModeOfSale.data[el.Id].tag,
                display_name: editedDataModeOfSale.data[el.Id].display_name,
                support_vente: salesSupport,
                isArchived: el.isArchived,
                isFavorite: el.isFavorite,
                shopId: el.shopId,
                state: el.state,
                advancedDisplayName:
                    editedDataModeOfSale.data[el.Id].advancedDisplayName,
            },
        },
        isShop: true,
        isAssociate: true,
    };
}

export function createOldData(el: any) {
    return {
        designation: el["Mode of sale"],
        tag: el.tag,
        display_name: el.display_name,
        support_vente: el.support_vente,
        isArchived: el.isArchived,
        state: el.state,
        isFavorite: el.isFavorite,
        shopId: [el.shopId],
        advancedDisplayName: el.advancedDisplayName,
    };
}

export function updateSalesSupport(
    oldData: any,
    el: any,
    editedDataModeOfSale: any,
    salesSupport: any
) {
    let updatedData = getSalesSupportUpdated(
        oldData,
        {
            designation: editedDataModeOfSale.data[el.Id].designation,
            tag: editedDataModeOfSale.data[el.Id].tag,
            display_name: editedDataModeOfSale.data[el.Id].display_name,
            support_vente: salesSupport,
            isArchived: el.isArchived,
            isFavorite: el.isFavorite,
            shopId: el.shopId,
            state: el.state,
            advancedDisplayName:
                editedDataModeOfSale.data[el.Id].advancedDisplayName,
        },
        "KIOSK",
        "support_vente"
    );

    if (
        updatedData.isSaleSupportKIOSKAdded === false &&
        updatedData.isSaleSupportKIOSKDeleted === false &&
        Object.keys(salesSupport).includes("KIOSK") === true
    ) {
        updatedData = {
            ...updatedData,
            isSaleMethodHasSaleSupportKIOSK: true,
        };
    }

    return updatedData;
}

export function handleToastMessages(
    error: any,
    isSalesSupportEmpty: any,
    isDataChanged: any,
    setLimit: any,
    setModalState: any,
    setDataIsUpdated: any,
    setGlobalDataIsUpdated: any,
    setIsLoading: any,
    setSalesSupport: any,
    setState: any
) {
    if (error === false) {
        if (!isSalesSupportEmpty.includes(false)) {
            showSuccessToast(t("The sales method is changed successfully")!);
        } else if (
            (isSalesSupportEmpty.includes(true) &&
                isSalesSupportEmpty.includes(false)) ||
            (!isSalesSupportEmpty.includes(true) && isDataChanged)
        ) {
            setLimit(2);
            toast.warn(
                `${t(
                    "Please note that the modification could not be made at one or more stores.Please check the data settings of the store(s)"
                )}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    theme: "colored",
                    icon: <CheckboxIcon height={25} width={25} fill="white" />,
                }
            );
            showSuccessToast(
                t("Shop sales method has been changed successfully")!
            );
        } else if (!isSalesSupportEmpty.includes(true) && !isDataChanged) {
            toast.warn(
                `${t(
                    "Please note that the modification could not be made at one or more stores.Please check the data settings of the store(s)"
                )}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    theme: "colored",
                    icon: <CheckboxIcon height={25} width={25} fill="white" />,
                }
            );
        }

        setDataIsUpdated(true);
        setGlobalDataIsUpdated(true);
        setModalState((prev: any) => ({
            ...prev,
            isAddModeOfSaleClicked: false,
        }));
        setSalesSupport([]);
        setState((prev: any) => ({
            ...prev,
            salesSupportData: [],
        }));

        setIsLoading(false);
    }
}
